import { Component, OnInit, viewChild } from '@angular/core';
import {
  idNameItem,
  JkBaseOption,
  JkComboboxComponent,
} from 'jk-service';
import { StkMa019List, stklg002List, stklgOrderList } from '../_service_stk';
import {
  JkdaterangeComponent,
  MaterialModule,
} from 'jk-service';
import { StockService } from '../services/stock.service';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule, JkbtneditComponent, JkmultiselectComponent, jkQueryComponent, JkrangeComponent } from 'jk-advcom';

class PageOption extends JkBaseOption {
  // ###
}

class FilterOption extends JkBaseOption {
  // ###
}

@Component({
  selector: 'app-stkpq08',
  templateUrl: './stkpq08.component.html',
  styleUrls: [],
  standalone: true,
  imports: [JackBaseComponentModule, MaterialModule, AdvComModule],
})
export class Stkpq08Page extends jkQueryComponent implements OnInit {
  override _programId = 'stkpq08'; // ###
  pageOpt: PageOption = new PageOption(this.programId + '_page'); //###
  filterOpt: FilterOption = new FilterOption(this.programId); //###
  readonly stklg001Com = viewChild.required<JkdaterangeComponent>('stklg001Com');
  readonly stkma019 = viewChild.required<JkComboboxComponent>('stkma019');
  readonly stklg002Com = viewChild.required<JkComboboxComponent>('stklg002Com');
  readonly stklg004 = viewChild.required<JkbtneditComponent>('stklg004');
  readonly stklg004r = viewChild.required<JkrangeComponent>('stklg004r');
  readonly stklg004m = viewChild.required<JkmultiselectComponent>('stklg004m');
  readonly cboOrder = viewChild.required<JkComboboxComponent>('orderBy');
  marketNo = '';
  //date1: string = '';
  //date2: string = '';
  date: string = this.nowDate();
  stockNo: string = '';
  stockNo1: string = '';
  stockNo2: string = '';
  stockNoList: idNameItem[] = [];
  kind: string = '1';
  // 種類 1:明細 2:日線未產生 3:日線統計
  kindList: idNameItem[] = [
    { id: '1', name: '明細' },
    { id: '2', name: '日線未產生' },
    { id: '3', name: '日線統計' },

  ];
  constructor() {
    super();
    this.setFormOpt2(); //###
    this.stockSrv.date1 = this.nowDate();
    this.logMessage = '無錯誤訊息';

    //this.stkma001List = await jkOpenWin.doOpenWin<idNameItem[]>('S','#STKMA001','V01',[]);
    this.addOpenwinLoadOption('#STKMA001', 'V01', 'S', [], this.stkma001List);
  }
  override ngOnInit() {
    super.ngOnInit();
    /*this.filterOpt = new FilterOption(this.programId); //###
    this.filterOpt.load(); //###
    this.pageOpt = new PageOption(this.programId + '_page'); //###
    this.pageOpt.load(); //###*/
  }

  override async ngAfterViewInit() {
    super.ngAfterViewInit();
    this.checkAllInit(this); // 這行要放在 ngAfterViewInit 最後  ###

  }
  ngOnExit() { }

  override onWindowResize() {
    // ###
    super.onWindowResize();
    //this.pageOpt.setColCount(window.innerWidth);
    this.popFilter.popUpWidth = window.innerWidth - 20;
  }
  override async beforeQuery(): Promise<boolean> {
    await super.beforeQuery(); // 1:明細 2:日線未產生 3:日線統計
    if (this.kind == '1') {
      //await this.init(this.programId,'S01','S',['LG001','LG002','LG003','LG004'],[]);
      this.type = 'S';
      this.winItem = 'S01';
      this.mainTable = this.programId; //['LG001','LG002','LG003','LG004'];
      this.where = '';
      this.where = this.stklg001Com().addWhere(this.where, 'LG001');
      this.where = this.stklg002Com().addWhere(this.where, 'LG002');
      this.where = this.stklg004().addWhere(this.where, 'LG004');
      this.where = this.stklg004r().addWhere(this.where, 'LG004');
      this.where = this.stklg004m().addWhere(this.where, 'LG004');
      this.where = this.stkma019().addWhere(this.where, 'MA019');
      this.order = 'ORDER BY LG001,LG002,LG003,LG004';
    }
    if (this.kind == '2') {
      this.type = 'S';
      this.winItem = 'S06';
      this.mainTable = 'STKLG';
      this.params = [this.stockSrv.date1];
      this.where = '';
      this.order = '';
      //this.masterGrid.doQuery2('STKLG','S06','S',this.where,'',this.params);
      //return false;
    }
    if (this.kind == '3') {
      this.type = 'S';
      this.winItem = 'S05';
      this.mainTable = 'STKLG';
      this.where = '';
      //this.where = this.stklg002.addWhere(this.where, 'LG002');
      this.where = this.stklg001Com().addWhere(this.where, 'LG001');
      this.order = '';
    }
    this.masterTabGroupIndex = 1;

    return true;
  }

  // ### [以上是必要的]================================
  stkma001List: idNameItem[] = [];
  get stkma019List() {
    return StkMa019List;
  }
  get stklg002List() {
    return stklg002List;
  }
  orderList = stklgOrderList; // idNameItem[] = [{'id':'ORDER BY LG001,LG002,LG003,LG004','name':'日期順序'},{'id':'ORDER BY LG001 DESC,LG002 DESC,LG003 DESC,LG004 DESC','name':'日期倒序'}];
  stockSrv: StockService = new StockService();

}
